import React, { useState, useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom'; // Import useLocation from React Router
import styled, { keyframes } from 'styled-components';
import AddThemeModal from './AddThemeModal'; // Import the AddThemeModal component
import { useDispatch, useSelector } from 'react-redux';
import { addThemes, updateProjects } from '../Redux/projectsSlice';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import DeleteIcon from '@mui/icons-material/Delete';
import NoteIcon from '@mui/icons-material/Note';
import CloseIcon from '@mui/icons-material/Close';

// Define the functional component
const KeywordProject = ({ listn }) => {
  const location = useLocation(); // Get the current location using React Router's useLocation
  const [project, setProject] = useState([]);
  const [showModal, setShowModal] = useState(false); // State to control the visibility of the modal
  const [selectedProjectIndex, setSelectedProjectIndex] = useState(null); // State to store the index of the selected project
  const [notes, setNotes] = useState('')
  const [showNotes, setShowNotes] = useState(false)
  const [selectedKeywordIndex, setSelectedKeywordIndex] = useState(null)
  const [selectedThemeIndex, setSelectedThemeIndex] = useState(null)
  const [rewriteNote, setRewriteNote] = useState(false)
  const [charCount, setCharCount] = useState(notes.trim().split('').length);
  const [noInput, setNoInput] = useState(false)

  const user = useSelector(state=> state.user.user)


  const gProjects = useSelector(state => state.projects.projects);

  const dispatch = useDispatch()

  const navigate = useNavigate()



  // Function to fetch projects and themes from the database
  let projectName
  useEffect(() => {
    if (gProjects) {
      setProject(gProjects)
      // Extract the project name from the URL
      projectName = decodeURIComponent(location.search.split('=')[1]);
      // Find the project with the matching name
      const cProject = gProjects.find(project => project.name?.toLowerCase() === projectName?.toLowerCase());
      setProject([cProject]);
    }
  }, [gProjects, location.search]);

  function deepClone(obj) {
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }
  
    let clone = Array.isArray(obj) ? [] : {};
  
    for (let key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        clone[key] = deepClone(obj[key]);
      }
    }
  
    return clone;
  }

  const themeNameExists = (newThemeName, currentProject) => {
    // Ensure currentProject and its themes are defined
    if (!currentProject || !currentProject[0].themes) {
        console.error('Current project or themes are undefined.');
        return false;
    }

    // Check if the new theme name already exists in the current project's themes
    const exists = currentProject[0].themes.some(theme => theme.name.trim() === newThemeName.trim());

    return exists;
};

  // Function to add a new theme to a project
  const addThemeC = async (themeName) => {
    if (project.length > 0) {

      if(!themeNameExists(themeName, project)) {
      const updatedProject = {
        ...project[0],
        themes: [...project[0].themes, { name: themeName, keywords: [] }]
      };

  
      // const userRef = doc(db, 'users', user.id)

      // let userDeepCopy = [...gProjects];

      // userDeepCopy = userDeepCopy.map(proj => {
      //   if (proj.name?.toLowerCase() === projectName?.toLowerCase() && proj.type === 'keyword') {
      //     return {...proj, themes: [...proj.themes, {name: themeName, keywords: []}]};
      //   }
      //   return proj;
      // });


      // await updateDoc(userRef, {projects: userDeepCopy})

      // listn()


      setProject([updatedProject]);
      setShowModal(false); // Close the modal after adding theme
      dispatch(addThemes({pName: project[0].name, updatedProject: updatedProject})); // Dispatch updated project to Redux store
    } else {
      alert('Theme name already exists. Please choose a different name.');
        return;
    }
  
  }
  };

  // Function to toggle accordion panel
const toggleAccordion = (projectIndex, themeIndex) => {
  setProject(prevProjects => {
    const updatedProject = prevProjects.map((p, index) => {
      if (index === projectIndex) {
        return {
          ...p,
          openThemeIndex: p.openThemeIndex === themeIndex ? null : themeIndex
        };
      }
      return p;
    });
    return updatedProject;
  });
};


  // Function to download project as CSV
  const downloadProject = (p) => {
    const heading = 'Project,Theme,Keyword,Volume,CPC,Intent,Difficulty,Notes\n'; // Added Notes heading
    const csvContent = heading + p.themes.map(theme =>
      theme.keywords.map(keyword =>
        `${p.name},${theme.name},${keyword.keyword},${keyword.volume == null? 'No Data': String(keyword.volume).replaceAll(',', '')},${keyword.cpc == null? 'No Data': keyword.cpc},${keyword.intent},${keyword.difficulty == 'NaN'? 'No Data': keyword.difficulty}${keyword.difficulty !== 'NaN' ? '%': ''},${keyword.notes || ''}` // Include notes, leave blank if undefined
      ).join('\n')
    ).join('\n');
  
    // Create a blob containing the CSV data
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
  
    // Create a download link and simulate a click
    const link = document.createElement('a');
    link.href = url;
    link.download = `${p.name}_keywords.csv`;
    document.body.appendChild(link);
    link.click();
  
    // Cleanup
    URL.revokeObjectURL(url);
  };
  

  // Function to download theme as CSV
  const downloadTheme = (p, theme) => {
    const heading = 'Project,Theme,Keyword,Volume,CPC,Intent,Difficulty,Notes\n'; // Added Notes heading
  
    const csvContent = heading +
      theme.keywords.map(keyword =>
        `${p.name},${theme.name},${keyword.keyword},${keyword.volume == null? 'No Data': String(keyword.volume).replaceAll(',', '')},${keyword.cpc == null? 'No Data': keyword.cpc},${keyword.intent},${keyword.difficulty == 'NaN'? 'No Data': keyword.difficulty}${keyword.difficulty !== 'NaN' ? '%': ''},${keyword.notes || ''}` // Include notes, leave blank if undefined
      ).join('\n');
  
    // Create a blob containing the CSV data
    const blob = new Blob([csvContent], { type: 'text/csv' });
  
    // Create a URL for the blob
    const url = URL.createObjectURL(blob);
  
    // Create a temporary link element
    const link = document.createElement('a');
    link.href = url;
    link.download = `${p.name}_${theme.name}_keywords.csv`; // Set filename
    document.body.appendChild(link);
  
    // Programmatically trigger a click event on the link to start the download
    link.click();
  
    // Cleanup: Remove the link element and revoke the Blob URL
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
  


  function formatNumberWithCommas(number) {
    // Convert the number to a string and add commas
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  
  function getTotalVolume(keywords) {
    // Calculate total volume
    const totalVolume = keywords.reduce((total, keyword) => {
      // If volume is a string, remove commas and convert to a float; handle null case
      const volume = keyword.volume !== null 
        ? parseFloat(String(keyword.volume).replace(/,/g, '')) || 0 // Convert to string and handle potential NaN
        : 0; // Default to 0 if volume is null
  
      return total + volume; // Accumulate the total volume
    }, 0);
  
    // Format the total volume with commas
    return formatNumberWithCommas(totalVolume);
  }



  const toggleModal = (projectIndex) => {
  

    setSelectedProjectIndex(projectIndex);
    setShowModal(!showModal);
  };

  const checkTypeKeyword = project[0]?.type === 'keyword'? true: false



  const removeTheme = (e, themeName) => {
    e.stopPropagation();
    e.preventDefault();

    // Check if project and projects are defined
    if (!project || !project[0] || !gProjects) {
        console.error('Project or projects array is undefined.');
        return;
    }

    const currentProject = project[0];

    // Create a new project object with the theme removed
    const updatedProject = {
        ...currentProject,
        themes: currentProject.themes.filter(theme => theme.name.trim().toLowerCase() !== themeName.trim().toLowerCase())
    };

    // Update the gProjects array with the updated project
    const updatedProjects = gProjects.map(p =>
        p.name === currentProject.name && p.type === 'keyword'
            ? updatedProject
            : p
    );

    // Update the projects state
    setProject([updatedProject]);

    // Optionally, update the gProjects array in your global state (if using Redux or another state management library)
    dispatch(updateProjects(updatedProjects));
    
};



const showNotesPopup = (it, ik) => {
  setShowNotes(true)
  setSelectedThemeIndex(it)
  setSelectedKeywordIndex(ik)
}

const closePopup = () => {
  setShowNotes(true)
  setSelectedThemeIndex(null)
  setSelectedKeywordIndex(null)
  setNoInput(false)
  setNotes('')
  setShowNotes(false)
  setRewriteNote(false)
}


const addNotesToKeyword = (propValue) => {
  // Step 1: Check if the input is valid
  if (notes?.trim() === '' || notes == null) {
    setNoInput(true);
    return;
  }

  // Step 2: Clone the current data array deeply
  const updatedThemes = project[0].themes.map((theme, themeIndex) => {
    if (themeIndex === selectedThemeIndex) {
      return {
        ...theme,
        keywords: theme.keywords.map((keyword, keywordIndex) => {
          if (keywordIndex === selectedKeywordIndex) {
            return {
              ...keyword,
              notes: propValue // Add or update notes
            };
          }
          return keyword; // Return the original keyword if not selected
        })
      };
    }
    return theme; // Return the original theme if not selected
  });

  // Step 3: Update the projects list
  const arr = [...gProjects];
  const projectsZero = arr.filter(p => !(p.name === project[0].name && p.type === 'keyword'));

  const updatedProjects = [
    ...projectsZero,
    {
      ...project[0], // Make sure to spread the first project
      themes: updatedThemes
    }
  ];

  // Step 4: Dispatch the updated projects
  dispatch(updateProjects(updatedProjects));

  // Close the popup
  closePopup();
};


const MAX_CHAR_LIMIT = 250;


const handleNoteChange = (e) => {

  const noteText = e.target.value;

  if (noteText.trim().split('').length <= MAX_CHAR_LIMIT) {
    setNotes(noteText);
    setCharCount(noteText.trim().split('').length);
  }
};



  return (
    <Container>
      {project?.map((p, projectIndex) => (
        <ProjectContainer key={projectIndex}>
          <span>Project<ProjectName>{p?.name}</ProjectName></span>
          <Button onClick={() => toggleModal(projectIndex)} style={{ margin: '30px 0 60px 0', width: 'fit-content', backgroundColor: 'transparent', border: '1px dashed dodgerblue', color: 'dodgerblue' }}>Add Theme</Button>
          <div style={{overflowX: 'hidden', overflowY: 'auto'}}>
            {p?.themes?.map((theme, themeIndex) => (
              <ThemeContainer key={themeIndex}>
                <AccordionButton onClick={() => toggleAccordion(projectIndex, themeIndex)}>
                  <span>{theme.name}</span>
                  <span className='keywords-length'>{theme.keywords.length} keywords</span>
                  <span className='keywords-length'>{getTotalVolume(theme.keywords)} total volume</span>
                  <DeleteIcon style={{marginLeft: 'auto'}} onClick={e=> removeTheme(e, theme.name)}/>
                </AccordionButton>
                {p.openThemeIndex === themeIndex && (
                  <AccordionContent isOpen={true} style={{overflowY: 'auto'}}>
                    {theme.keywords.length === 0 ? (
                      <Message>No keywords yet for this theme. Please use the <span style={{color: 'dodgerblue', cursor: 'pointer'}} onClick={()=> navigate('/keyword-research')}>keyword research</span> tool to find and add relevant keywords.</Message>
                    ) : (
                      <>
                        <KeywordItem>
                          <KeywordHeading>Keyword</KeywordHeading>
                          <VolumeHeading style={{width: '170px'}}>Volume</VolumeHeading>
                          <CPCHeading style={{width: '100px'}}>CPC</CPCHeading>
                          <CPCHeading style={{width: '160px'}}>Intent</CPCHeading>
                          <CPCHeading style={{width: '100px', marginRight: '130px'}}>Difficulty</CPCHeading>
                        </KeywordItem>
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                        {theme.keywords.map((keyword, keywordIndex) => (
                          <KeywordItem key={keywordIndex}>
                            <Keyword style={{color: '#065eb7'}}>{keyword.keyword}</Keyword>
                            <Volume style={{width: '170px'}}>{keyword.volume == null? 'No Data': keyword.volume}</Volume>
                            <CPC style={{width: '100px'}}>{keyword.cpc == null? 'No Data': keyword.cpc}</CPC>
                            <CPC style={{width: '160px', color: keyword.intent.toLowerCase() === 'informational'? 'dodgerblue': keyword.intent.toLowerCase() === 'commercial'? 'green': keyword.intent.toLowerCase() === 'mixed'? 'lightpink': 'gray'}}>{keyword.intent}</CPC>
                            <CPC style={{width: '100px'}}>{keyword.difficulty == 'NaN'? 'No Data': keyword.difficulty}{keyword.difficulty !== 'NaN' && '%'}</CPC>
                                        {!keyword.notes && <p className='add_notes' onClick={()=> showNotesPopup(themeIndex, keywordIndex)}>
                                          <NoteIcon />
                                          Add Notes
                                        </p>}
                                        {keyword.notes && <p className='icons' style={{color: '#d9b810'}}><NoteIcon 
                                          className='notes_btn'
                                          onClick={()=> showNotesPopup(themeIndex, keywordIndex)}
                                        /></p>}
                          </KeywordItem>
                        ))}</div>
                        </>
                    )}
                    {theme.keywords.length > 0 && (
                      <DownloadButton onClick={() => downloadTheme(p, theme)} style={{ backgroundColor: 'rgb(236, 246, 255)', color: 'dodgerblue', marginTop: '50px' }}>Download Theme as CSV</DownloadButton>
                    )}
                  </AccordionContent>
                )}
              </ThemeContainer>
            ))}
          </div>
          {checkTypeKeyword && (
            <DownloadButton onClick={project[0]?.themes?.length !== 0 ? () => downloadProject(p) : undefined} style={{ position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-230%)', marginBottom: '23px', width: 'fit-content', backgroundColor: project[0]?.themes?.length === 0? 'lightgray': ''}}>Download Project as CSV</DownloadButton>
          )}
          {showModal && (
            <AddThemeModal
              onAddTheme={addThemeC}
              onClose={() => setShowModal(false)}
            />
          )}
        </ProjectContainer>
      ))}

      {showNotes && <PopupOverlay>
                  <PopupContent>
                    <PopupHeader>
                      {!project[0]?.themes[selectedThemeIndex]?.keywords[selectedKeywordIndex]?.notes && <h3>Add notes to <span>{project[0]?.themes[selectedThemeIndex]?.keywords[selectedKeywordIndex]?.keyword}</span></h3>}
                      {project[0]?.themes[selectedThemeIndex]?.keywords[selectedKeywordIndex]?.notes && <h3>Notes for <span>{project[0]?.themes[selectedThemeIndex]?.keywords[selectedKeywordIndex]?.keyword}</span></h3>}
                      <CloseButton onClick={()=> closePopup()}><CloseIcon /></CloseButton>
                    </PopupHeader>
                    {project[0]?.themes[selectedThemeIndex]?.keywords[selectedKeywordIndex]?.notes && !rewriteNote && <p>{project[0]?.themes[selectedThemeIndex]?.keywords[selectedKeywordIndex]?.notes}</p>}
                    <PopupBody>
                      {(!project[0]?.themes[selectedThemeIndex]?.keywords[selectedKeywordIndex]?.notes || rewriteNote) && <textarea
                        value={notes}
                        onChange={(e) => handleNoteChange(e)}
                        placeholder="Write your note here..."
                        style={{borderColor: noInput? 'red': ''}}
                        maxlength={MAX_CHAR_LIMIT}
                      />}
                      {(!project[0]?.themes[selectedThemeIndex]?.keywords[selectedKeywordIndex]?.notes || rewriteNote) && <CharCounter>{charCount}/{MAX_CHAR_LIMIT} characters</CharCounter>}
                    </PopupBody>
                    <PopupFooter>
                      {(!project[0]?.themes[selectedThemeIndex]?.keywords[selectedKeywordIndex]?.notes || rewriteNote) && <button className="save" onClick={()=> addNotesToKeyword( notes)}>Save</button>}
                      {project[0]?.themes[selectedThemeIndex]?.keywords[selectedKeywordIndex]?.notes && !rewriteNote && <button className="cancel" onClick={()=> setRewriteNote(true)}>Overwrite Note?</button>}
                    </PopupFooter>
                  </PopupContent>
                </PopupOverlay>}
    </Container>
  );
};

// Define styled components
const Container = styled.div`
  background-color: #f2f2f2;
  padding: 20px;
  width: 78.5%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  z-index: 10000;
`;

const fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

const ProjectContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* border: 1px solid #ccc; */
  border-radius: 4px;
  margin-bottom: 45px;
  padding: 16px;
  /* background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
  flex: 1;
  padding-bottom: 50px;
`;

const ProjectName = styled.h2`
  margin-bottom: 10px;
  font-family: 'Lexend';
  font-weight: 300;
  font-size: 37px;
`;

const ThemeContainer = styled.div`
  margin-top: 0px;
`;

const Button = styled.button`
  padding: 8px 16px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-bottom: 16px;
  margin-right: 10px;
  
  &:hover {
    background-color: #0056b3;
  }
`;

const AccordionButton = styled(Button)`
  width: 100%;
  text-align: left;

  display: flex;
  flex-direction: row;
  align-items: center;
  

  > span {
    width: 300px;
  }

  > .keywords-length {
    width: 180px;
    margin-left: 160px;
  }
`;

const AccordionContent = styled.div`
  max-height: ${({ isOpen }) => (isOpen ? '1000px' : '0')};
  overflow: hidden;
  transition: max-height 0.3s ease-out;
`;

const KeywordItem = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  background-color: #fafafa;
  border-radius: 4px;
  margin-top: 8px;

  > .icons {
    margin-right: 20px;
    width: 100px;
    display: flex;
    align-items: center;
    gap: 5px;
    transition: color 0.3s ease-in-out;

    > .MuiSvgIcon-root {
      font-size: larger;
      cursor: pointer;
    }

    &:hover {
      color: dodgerblue;
    }
  }

  > .add_notes {
    font-family: 'Quicksand';
    margin-right: 25px;
    cursor: pointer;
    color: #aaaaaa;
    transition: color 0.3s ease-in-out;
    display: flex;
    align-items: center;
    gap: 3px;
    width: 100px;

    > .MuiSvgIcon-root {
      font-size: medium;
    }

    &:hover {
      color: #f2d025;
    }
  }
`;

const KeywordHeading = styled.span`
  flex: 1;
  font-weight: bold;
`;

const VolumeHeading = styled.span`
  margin-right: 16px;
  font-weight: bold;
`;

const CPCHeading = styled.span`
  font-weight: bold;
`;

const Keyword = styled.span`
  flex: 1;
`;

const Volume = styled.span`
  margin-right: 16px;
`;

const CPC = styled.span``;

const DownloadButton = styled(Button)`
  background-color: #28a745;
  margin-top: 16px;
  
  &:hover {
    background-color: #218838;
  }
`;

const Message = styled.div`
  padding: 8px;
`;


const PopupOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 10px;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100000;
  opacity: 0;
  animation: ${fadeInAnimation} 0.2s ease-in-out forwards;
`;

const PopupContent = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  z-index: 10000;
  width: 400px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  > p {
    font-family: 'Quicksand';
    font-size: 21px;
    width: 95%;
    margin: 20px 0 30px 0;
    word-break: break-all;
  }
`;

const PopupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;

  > h3 {
    font-size: large;
    font-weight: 500;
    color: #065eb7;
    margin-right: 20px;
    font-family: 'Quicksand';

    > span {
      font-family: 'Quicksand';
      font-weight: bold;
    }
  }
`;

const CloseButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    color: red;
  }
`;

const PopupBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
  margin-bottom: 20px;

  > textarea {
    width: 90% !important;
    height: 120px; /* Fixed height */
    padding: 15px;
    border: 1px solid #d1d1d1; /* Light gray border */
    border-radius: 8px; /* Rounded corners */
    outline: none;
    font-family: 'Quicksand', sans-serif;
    font-size: 14px;
    resize: none; /* Prevent resizing */
    background-color: #fafafa; /* Soft background color */
    color: #333; /* Dark text for better readability */
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);

    &:focus {
      border-color: #065eb7; /* Border color change on focus */
      background-color: white; /* Slightly brighter on focus */
    }

    &::placeholder {
      color: #b3b3b3; /* Placeholder text color */
      font-style: italic;
    }
  }
`;



const PopupFooter = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  width: 100%;

  > button {
    padding: 10px 20px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    font-family: 'Quicksand', sans-serif;
    transition: background-color 0.3s ease-in-out;

    &.cancel {
      background-color: lightgray;

      &:hover {
        background-color: darkgray;
      }
    }

    &.save {
      background-color: #065eb7;
      color: white;

      &:hover {
        background-color: #f2d025;
      }
    }
  }
`;


const CharCounter = styled.div`
  font-size: 12px;
  color: #666;
  text-align: right;
  margin-top: 8px;
`;



export default KeywordProject;
